import PatcraftApi from "../../../scripts/patcraft-api";

// Initial state
const state = () => ({
  pageNumber: 1,
  pageSize: size > 0 ? size : 16,
  totalPages: 0,
  isFetching: false,
  items: [],
  totalCount: 0
});

let size = 0;
const urlSearchParams = new URLSearchParams(window.location.search);
if(urlSearchParams.get('Page') !==  null) {
  size = size !== null && size <= 16 ? (parseInt(urlSearchParams.get('Page')) * 16) : 16;
}

// Getters
const getters = {
  items: (state, getters, rootState) => {
    return state.items;
  },
  pageNumber: (state, getters, rootState) => {
    return state.pageNumber;
  },
  pageSize: (state, getters, rootState) => {
    return state.pageSize;
  },
  totalCount: (state, getters, rootState) => {
    return state.totalCount;
  },

  isFetching: state => {
    return state.isFetching;
  },
  showLoadMore: state => {
    return (
      state.totalPages > state.pageNumber ||
      (state.isFetching && state.items.length === 0)
    );
  }
};

// Actions
const actions = {
  fetchResults({ commit, state, dispatch }, data) {
    commit("setTotalCount", { totalCount: 0 });
    if (state.isFetching) {
      return;
    }
    dispatch("setIsFetching", true);
    if (state.pageNumber === 1) {
      dispatch("setResults", []);
      PatcraftApi.getProductFilters({ filter: { ...data.filter, PageSize: 0 } })
        .then(res => {
          dispatch(
            "filters/updateFilterOptions",
            { filters: [...res.data] },
            { root: true }
          );
        })
        .catch(err => {
          console.log(err);
        });
    }

    PatcraftApi.searchProduct(data)
    .then(res => {
      //Display Multiple Color Filters
      //If user has color filter selections, for every product fetched, sort its colors array based on user selected colors
      if(data.filter.ColorFamily != undefined) {
        let colorsArray = data.filter.ColorFamily.split(',');
        for(let i = 0; i <= res.data.items.length -1; i++) {
          for(let j = 0; j <= colorsArray.length; j++) {
            res.data.items[i].colors.sort(function(a,b) {
              if(a.colorFamily.description === colorsArray[j]) return -1;
              else if(b.colorFamily.description === colorsArray[j]) return 1;
              else return 0;
            });
          }
        };
      }
      commit("setResults", { results: [...res.data.items] });
      commit("setTotalPages", { pages: res.data.totalPages });
      commit("setTotalCount", { totalCount: res.data.totalCount });
      dispatch("setIsFetching", false);

    })
    .catch(error => {
      dispatch("setIsFetching", false);
    });
  },
  setPageNumber({ commit }, page) {
    commit("setPageNumber", { page });
  },
  setResults({ commit }, results) {
    commit("setResults", { results });
  },
  setIsFetching({ commit }, value) {
    commit("setIsFetching", { value });
  }
};

// Mutations
const mutations = {
  setPageNumber(state, { page }) {
    state.pageNumber = page;
  },
  setResults(state, { results }) {
    if (state.pageNumber > 1) {
      state.items = [...state.items, ...results];
    } else {
      state.items = [...results];
    }
  },
  setIsFetching(state, { value }) {
    state.isFetching = value;
  },
  setTotalPages(state, { pages }) {
    state.totalPages = pages;
  },
  setTotalCount(state, { totalCount }) {
    state.totalCount = totalCount;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
